/**
 * TertiaryMenu component.
 * @module components/ItaliaTheme/Header/HeaderSlim/TertiaryMenu
 */

import cx from 'classnames';
import { useIntl } from 'react-intl';
import { Nav, NavItem, NavLink } from 'design-react-kit';
import { UniversalLink } from '@plone/volto/components';
import { getSiteProperty } from 'design-comuni-plone-theme/helpers';

const TertiaryMenu = () => {
  const intl = useIntl();

  const staticMenu =
    getSiteProperty('headerslimTertiaryMenu', intl.locale) ?? [];

  return staticMenu?.length > 0 ? (
    <Nav vertical={false} className="tertiary-menu">
      {staticMenu.map((navitem, id) => (
        <NavItem
          tag="li"
          key={id}
          className={cx('', { 'in-evidence': navitem.inEvidence })}
        >
          <NavLink href={navitem.url} tag={UniversalLink}>
            <span>{navitem.title}</span>
          </NavLink>
        </NavItem>
      ))}
    </Nav>
  ) : null;
};

export default TertiaryMenu;
